import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import Registry from "@/Components/Front/SVGS/Services/Registry";
import LineaDb from "@/Components/Front/SVGS/LineaDb";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import LineaData from "@/Components/Front/SVGS/LineaData";
import LineaData2 from "@/Components/Front/SVGS/LineaData2";
import Gad from "@/Components/Front/PNGS/grad-registry.png";
import Header from "@/Components/Front/Header";
import {useMediaQuery} from "react-responsive";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";

export default function ServicesDataScience(props) {

    const [lang, setLang] = useLang(props.locale);
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 1023px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})

    const textProps = {
        lang: lang, language: props.language,
    };


    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-registry-program-design"}/>

            <section id="registry" className={"services-page"}>
                {isMobileAndTabletPortrait &&
                    <>
                    <div className={"back-arrow"}>
                        <Link href={"/"}>
                            <ChevronRightAlt/>
                        </Link>
                    </div>
                    <div className={"mobile-image"}>
                        <img src="images/RegistrySmall.svg" alt=""/>


                    </div>
                    </>
                }
                <div className="in-frame-inner">

                    {isLg &&
                        <>
                            <div className={"section-gradient"}>
                                <img src={Gad} alt=""/>
                            </div>
                            <div className={"section-background"}>

                                <Registry/>
                            </div>
                        </>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaData2/>
                        </div>
                        <div className={"service-back-button"}>
                            <ArrowBack/>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"registry-title-1"}/></span>
                            <span><Text {...textProps} str={"registry-title-2"}/></span>
                            <span><Text {...textProps} str={"registry-title-3"}/></span>
                        </h1>
                        <p>
                            <Text {...textProps} str={"registry-text-1"} html={true}/>
                        </p>
                        <p>
                            <Text {...textProps} str={"registry-text-2"} html={true}/>
                        </p>
                    </div>


                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
